<template>
  <div>
    <el-dialog
      :visible.sync="ifShow"
      :title="title"
      width="900px"
      @close="$emit('closeDialog', false)"
    >
      <div>
        <el-form
          ref="goodsForm"
          :model="addPopData"
          :rules="rules"
          label-position="right"
          label-width="7rem"
        >
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="公司名称" prop="companyName" required>
                <el-input v-model="addPopData.companyName" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="公司地址" prop="companyAddress" required>
                <el-input v-model="addPopData.companyAddress" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="联系人" prop="customerName" required>
                <el-input v-model="addPopData.customerName" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话" prop="customerPhone" required>
                <el-input v-model="addPopData.customerPhone" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="客户类型" prop="customerType" required>
                <el-select v-model="addPopData.customerType" placeholder="请选择">
                  <el-option label="svip" value="1" />
                  <el-option label="vip" value="2" />
                  <el-option label="普通客户" value="3" />
                  <el-option label="老客户" value="4" />
                  <el-option label="合作伙伴" value="5" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="固定电话" prop="fixTelphone">
                <el-input v-model="addPopData.fixTelphone" v-input-filter />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="是否业务用户" prop="isBusiness" required>
                <el-select v-model="addPopData.isBusiness" placeholder="请选择">
                  <el-option label="否" value="1" />
                  <el-option label="是" value="2" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="客户成熟度" prop="customerMaturity" required>
                <el-select v-model="addPopData.customerMaturity" placeholder="请选择">
                  <el-option label="明确成交意向" value="1" />
                  <el-option label="有初步成交意向" value="2" />
                  <el-option label="关键人有成交意向" value="3" />
                  <el-option label="关键人成交,意向不确定" value="4" />
                  <el-option label="初步联系，有意向" value="5" />
                  <el-option label="初步联系，意向不确定" value="6" />
                  <el-option label="新建客户" value="7" />
                  <el-option label="明显拒绝" value="8" />
                  <el-option label="无效客户" value="9" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="建立客户时间" prop="createDate" required>
                <el-date-picker
                  v-model="addPopData.createDate"
                  type="datetime"
                  :editable="false"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期"
                  :picker-options="pickerBeginDateBefore"
                  @change="changeTime"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="跟进时间">
                <el-date-picker
                  v-model="addPopData.followDate"
                  type="datetime"
                  :editable="false"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期"
                  :picker-options="pickerBeginDateAfter"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="备注">
                <el-input v-model="addPopData.remarks" type="textarea" />
                <span>还可以输入{{ this.titleMaxLength - this.addPopData.remarks.length }}个字</span>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="add-pop-btn" @click="addSubmission('goodsForm')">
            提交
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import * as get from '@/api/personal/customer/business-enterprise/index.js' // 请求接口
import inputFilter from '@/directives/validation/index.js'
import { dateCheck } from '@/utils/dateCheck.js'

export default {
  directives: {
    inputFilter
  },
  // 混入时间校验
  mixins: [dateCheck],
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '业务公司-新增'
    },
    popData: {
      type: [Object, String],
      default: ''
    },
    status: {
      type: String,
      default: ''
    }
  },
  data() {
    var checking = (rule, value, callback) => {
      get.getAddList({
        companyName: value
      }).then(res => {
        if (value == this.companyIf) {
          callback()
        } else if (res.message == '该公司已存在') {
          callback(new Error('该公司已存在'))
        } else {
          callback()
        }
      }).catch(error => {
        console.log(error)
      })
    }
    return {
      // 开始日期
      pickerBeginDateBefore: {
        disabledDate: (time) => {
          const beginDateVal = this.addPopData.createDate
          if (beginDateVal) {
            return time.getTime() > beginDateVal
          }
        }
      },
      // 结束时间
      pickerBeginDateAfter: {
        disabledDate: (time) => {
          const beginDateVal = this.addPopData.followDate
          if (beginDateVal) {
            return time.getTime() < beginDateVal
          }
        }
      },

      ifShow: this.dialogShow,
      // 保存和编辑 备注内容、字数
      titleMaxLength: 255,
      // 正则
      rules: {
        // 公司
        companyName: [
          { required: true, message: '必填' },
          { pattern: /^([a-zA-Z0-9_\u4e00-\u9fa5]){3,}$/, message: '请输入有效的公司' },
          // { validator: this.$validate('company') },
          { trigger: 'blur', validator: checking },
          { min: 3, max: 20, message: '请输入3-20字' }
        ],
        // 地址
        companyAddress: [
          { required: true, message: '必填' },
          { pattern: /^(?=.*?[\u4E00-\u9FA5])[\dA-Za-z\u4E00-\u9FA5]+$/, message: '请输入正确格式' },
          { min: 2, max: 50, message: '请输入2-50字' }
        ],
        // 联系人
        customerName: [
          { required: true, message: '必填' },
          { pattern: /^[\u4e00-\u9fa5a-zA-Z]{1,}$/, message: '请输入有效的姓名' },
          // { validator: this.$validate('names') },
          { min: 2, max: 25, message: '请输入2-25字' }
        ],
        // 联系电话
        customerPhone: [
          { required: true, message: '必填' },
          { validator: this.$validate('phone') }
        ],
        // 固定电话
        fixTelphone: [
          { pattern: /^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$/, message: '请输入正确固话' }
          // { validator: this.$validate('fixedLine') }
        ],
        customerType: [{ required: true, message: '必填' }],
        isBusiness: [{ required: true, message: '必填' }],
        customerMaturity: [{ required: true, message: '必填' }],
        createDate: [{ required: true, message: '必填' }]
      },
      // 新增业务数据
      // companyName: '', // 公司名称
      // companyAddress: '', // 公司地址
      // relationName: '', // 联系人
      // relationPhone: '', // 联系电话
      // fixTelphone: '', // 固定电话
      // customerType: '', // 客户类型
      // isBusiness: '', // 是否业务用户
      // customerMaturity: '', // 客户成熟度
      // createDate: '', // 建立客户时间
      // followDate: '', // 跟进时间
      // remarks: '', // 备注
      // id: ''
      addPopData: this.popData,
      companyIf: ''
    }
  },
  watch: {
    'addPopData.remarks'() {
      if (this.addPopData.remarks.length > this.titleMaxLength) {
        this.addPopData.remarks = String(this.addPopData.remarks).slice(0, this.titleMaxLength)
      }
    }
  },
  created() {
    // 判断是否是编辑（公司查重用）
    this.companyIf = this.popData.companyName
  },
  methods: {
    // 选择开始时间，清空结束时间
    changeTime(date) {
      this.addPopData.followDate = ''
      this.pickerBeginDateAfter = {
        disabledDate(time) { // 开始时间-结束时间
          return (time.getTime() < new Date(date).getTime())
        }
      }
    },
    // 新增提交按钮
    addSubmission(formName) {
      // 正则匹配
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.status == 'create') {
            get.AddList(this.addPopData).then(res => {
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              // 添加完成后刷新列表
              this.$emit('EchoClick', false)
              this.$emit('closeDialog', false)
            }).catch(error => {
              console.log(error)
            })
          } else {
            get.editSubForm(this.addPopData).then(res => {
              this.$message({
                message: '修改成功',
                type: 'success'
              })
              // 添加完成后刷新列表
              this.$emit('EchoClick', false)
              this.$emit('closeDialog', false)
            }).catch(error => {
              console.log(error)
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped lang='scss'>
  .el-select, .el-cascader {
    width: 100% !important;
  }
  /deep/ .el-date-editor.el-input {
    width: 100% !important;
  }
  .no-data-info {
    background-color: #fff;
    width: 100%;
    text-align: center;
    margin-top: 8px;
    height: 48px;
    line-height: 48px;
    font-size: 15px;
  }
  .add-pop-btn{
    width:100px;
    height:40px;
    line-height: 40px;
    text-align: center;
    margin: 0 auto;
    background:rgba(190,35,22,1);
    border-radius:4px;
    color: #FFFFFF;
    font-size: 18px;
    cursor: pointer;
  }
</style>
